import BaseObject from '../../base/base_object';

export default class EventsObjectBuilder extends BaseObject {
    static CLASS = 'EventsObjectBuilder';
    init(params) {
        this.serviceFactory = params.serviceFactory;
        this._handlersModulesReader = params.handlersModulesReader || this._handlersModulesReader;
    }

    _handlersModulesReader = {
        read: () => {
            let handlersContext = require.context('./action_handlers/', true, /^.*(_actionhandler)\.js$/);
            return handlersContext.keys().map(handlersContext);
        }
    };


    _eventsObject = null;
    buildEventsObject() {
        if(!this._eventsObject) {

            this._eventsObject = {};

            this._handlersModulesReader.read().forEach(handlerModule => {
                let handler = handlerModule.default.create({
                    serviceFactory: this.serviceFactory
                });

                this._eventsObject[handler.actionName()] = handler.execute.bind(handler);
            });
        }

        return this._eventsObject;
    }
}